let dd = require("ES/lib/dd");
let AuthedUserSession = require("../../utils/AuthedUserSession");

module.exports = dd.createClass({
	render: function(){
		let mobile_app_url = AuthedUserSession.is_privatelabel
			? null//privatelabels currently don't have a mobile app
			: "https://www.espeakers.com/wiki/Download_eSpeakers_App";

		return dd.div({className: "your-browser-window-is-too-small text-center hidden-lg hidden-md"},
			dd.div({className: "relative"},
				dd.div({className: "glass"}),
				dd.div({className: "body"},
					dd.div({className: "panel panel-default"},
						dd.div({className: "panel-body"},
							dd.h2(null, "Squeezed! Your window is too narrow for this."),
							mobile_app_url ? dd.div(null,
								dd.h3(null, dd.i({className: "fa fa-mobile"}), " If you are on a mobile device:"),
								dd.a({href: mobile_app_url}, "Click here"), " to get our free mobile app.",
								dd.h3(null, dd.i({className: "fa fa-desktop"}), " If you are on a desktop:")
							) : null,
							"Stretch this window wider."
						)
					)
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/YourBrowserWindowIsTooSmall.js